import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { FaCalendarAlt } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const Navbar = ({ t, activeSection, scrollToSection }) => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const isBookingPage = location.pathname === '/bookings';

  const handleNavClick = (section) => {
    scrollToSection(section);
    setExpanded(false);
  };

  return (
    <BootstrapNavbar 
      expand="lg" 
      fixed="top" 
      className="navbar-custom"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <BootstrapNavbar.Brand 
          onClick={() => handleNavClick('home')}
          style={{ cursor: 'pointer' }}
          className="hover-scale animate-bounce-in"
        >
          <span className="animate-heartbeat">🏥</span> Physio Sphere
        </BootstrapNavbar.Brand>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto stagger-animation">
            <Nav.Link 
              onClick={() => handleNavClick('home')}
              className={`hover-glow animate-slide-up ${activeSection === 'home' ? 'active' : ''}`}
              style={{'--i': 0}}
            >
              {t.nav.home}
            </Nav.Link>
            <Nav.Link 
              onClick={() => handleNavClick('about')}
              className={`hover-bounce animate-slide-up ${activeSection === 'about' ? 'active' : ''}`}
              style={{'--i': 1}}
            >
              {t.nav.about}
            </Nav.Link>
            <Nav.Link 
              onClick={() => handleNavClick('services')}
              className={`hover-scale animate-slide-up ${activeSection === 'services' ? 'active' : ''}`}
              style={{'--i': 2}}
            >
              {t.nav.services}
            </Nav.Link>
            <Nav.Link 
              onClick={() => handleNavClick('gallery')}
              className={`hover-rotate animate-slide-up ${activeSection === 'gallery' ? 'active' : ''}`}
              style={{'--i': 3}}
            >
              {t.nav.gallery}
            </Nav.Link>
            <Nav.Link 
              onClick={() => handleNavClick('contact')}
              className={`hover-lift animate-slide-up ${activeSection === 'contact' ? 'active' : ''}`}
              style={{'--i': 4}}
            >
              {t.nav.contact}
            </Nav.Link>
            
            {/* Mobile Book Appointment Link */}
            <Nav.Link 
              as={Link}
              to="/bookings"
              className={`hover-scale animate-slide-up d-md-none ${isBookingPage ? 'active' : ''}`}
              style={{'--i': 5}}
              onClick={() => setExpanded(false)}
            >
              <FaCalendarAlt className="me-2" />
              {t.nav?.bookAppointment || 'Book Appointment'}
            </Nav.Link>
          </Nav>
          
          <div className="d-flex align-items-center gap-2">
            {/* Book Appointment Button */}
            <Link 
              to="/bookings" 
              className="btn btn-primary hover-scale animate-pulse d-none d-md-block btn-icon-only"
              style={{ textDecoration: 'none' }}
              title={t.nav?.bookAppointment || 'Book Appointment'}
              aria-label={t.nav?.bookAppointment || 'Book Appointment'}
            >
              <FaCalendarAlt />
            </Link>
            <ThemeToggle />
          </div>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;